import { render, staticRenderFns } from "./slide.vue?vue&type=template&id=52b32431&scoped=true"
import script from "./slide.vue?vue&type=script&lang=js"
export * from "./slide.vue?vue&type=script&lang=js"
import style0 from "./slide.vue?vue&type=style&index=0&id=52b32431&prod&scoped=true&lang=css"
import style1 from "./slide.vue?vue&type=style&index=1&id=52b32431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b32431",
  null
  
)

export default component.exports